/* tslint:disable */
 
export class SmsLog {

  /**
   * The body of the SMS.
   */
  body?: string;

  /**
   * The error message generated in case an exception is thrown
   */
  errorMessage?: string;

  /**
   * The timestamp when the SMS was generated by the system.
   */
  generatedAt?: string;
  id?: string;

  /**
   * The message id from the service bus.
   */
  messageId?: string;

  /**
   * The related trigger execution id if the SMS was sent as a result of a trigger.
   */
  relatedTriggerExecutionId?: string;

  /**
   * The response returned frm the SMS provider.
   */
  smsProviderResponse?: any;

  /**
   * Whether the SMS was sent successfully or not.
   */
  status?: string;

  /**
   * The strategy used for sending the SMS.
   */
  strategy?: string;

  /**
   * The timestamp when the SMS was sent.
   */
  timestamp?: string;

  /**
   * The recipients of the SMS.
   */
  to?: (string | Array<string>);
}
